import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";

import AddServer from "./pages/AddServer";
import AddTag from "./pages/AddTag";
import HomePage from "./pages/HomePage";
import GraphPage from "./pages/GraphPage";
import LoginPage from "./pages/LoginPage";
import DynamicPage from "./pages/DynamicPage";
import PageBuilder from "./pages/PageBuilder";
import ProcessDevelopment from "./pages/ProcessDevelopment";
import ProductionLine from "./pages/ProductionLine";
import DesignerPage from "./pages/DesignerPage";
import RuntimePage from "./pages/RuntimePage";

import ProtectedRoute from "./components/ProtectedRoute";
import API from "./services/api";

import "./App.css";
import logo from "./assets/logo.png";

const AppContent = ({ isAuthenticated, setIsAuthenticated }) => {
  const location = useLocation();
  const [runtimePages, setRuntimePages] = useState([]);
  const [runtimeMenuOpen, setRuntimeMenuOpen] = useState(false);

  // const hideHeader = location.pathname.startsWith("/runtime/");

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    window.location.href = "/login";
  };

  const fetchRuntimePages = async () => {
    try {
      const res = await API.get("/designer/pages/");
      const pages = Array.isArray(res.data) ? res.data : [];

      setRuntimePages(
        pages.filter((page) => page.is_published === true)
      );
    } catch (err) {
      console.error("Failed to load runtime pages:", err);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchRuntimePages();
    }
  }, [isAuthenticated]);

  return (
    <>
      {/*{!hideHeader && (*/}
        <header className="app-header">
          <div className="logo-container">
            <img src={logo} alt="NovNat Logo" className="company-logo" />
          </div>

          <nav className="nav-links">
            <Link to="/">Home</Link>

            {isAuthenticated ? (
              <>
                <Link to="/add-server">Add Server</Link>
                <Link to="/add-tag">Add Tag</Link>
                <Link to="/graph">Graph</Link>
                <Link to="/production">Production Line</Link>
                <Link to="/process-development">Process Development</Link>
                <Link to="/page-builder">Page Builder</Link>
                <Link to="/designer">Designer</Link>

                <div className="runtime-menu">
                  <button
                    type="button"
                    className="runtime-menu-button"
                    onClick={() => setRuntimeMenuOpen((prev) => !prev)}
                  >
                    Runtime Pages ▾
                  </button>

                  {runtimeMenuOpen && (
                    <div className="runtime-dropdown">
                      {runtimePages.length === 0 ? (
                        <div className="runtime-empty">No published pages</div>
                      ) : (
                        runtimePages.map((page) => (
                          <Link
                            key={page.id}
                            to={`/runtime/${page.id}`}
                            className="runtime-dropdown-item"
                            onClick={() => setRuntimeMenuOpen(false)}
                          >
                            {page.title}
                          </Link>
                        ))
                      )}
                    </div>
                  )}
                </div>

                <button onClick={handleLogout} className="logout-button">
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login">Login</Link>
            )}
          </nav>
        </header>
      {/*)}*/}

      <Routes>
        <Route
          path="/login"
          element={<LoginPage setIsAuthenticated={setIsAuthenticated} />}
        />

        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        <Route path="/add-server" element={<ProtectedRoute><AddServer /></ProtectedRoute>} />
        <Route path="/add-tag" element={<ProtectedRoute><AddTag /></ProtectedRoute>} />
        <Route path="/graph" element={<ProtectedRoute><GraphPage /></ProtectedRoute>} />
        <Route path="/production" element={<ProtectedRoute><ProductionLine /></ProtectedRoute>} />
        <Route path="/process-development" element={<ProtectedRoute><ProcessDevelopment /></ProtectedRoute>} />
        <Route path="/page-builder" element={<ProtectedRoute><PageBuilder /></ProtectedRoute>} />
        <Route path="/p/:id" element={<ProtectedRoute><DynamicPage /></ProtectedRoute>} />
        <Route path="/designer" element={<ProtectedRoute><DesignerPage /></ProtectedRoute>} />

        <Route path="/runtime/:id" element={<RuntimePage />} />
      </Routes>
    </>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <Router>
      <AppContent
        isAuthenticated={isAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
      />
    </Router>
  );
};

export default App;